import { render, staticRenderFns } from "./TransactionsHistory.vue?vue&type=template&id=5204413f&scoped=true"
import script from "./TransactionsHistory.vue?vue&type=script&lang=ts"
export * from "./TransactionsHistory.vue?vue&type=script&lang=ts"
import style0 from "./TransactionsHistory.vue?vue&type=style&index=0&id=5204413f&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5204413f",
  null
  
)

export default component.exports